import { getEntityFromString } from 'utils/getEntityFromString';
import { ensureRoute } from 'utils/routes';

const ACTION_DEFINITIONS = {
    'show-entity-detail': {
        cta: 'Take me to the related entity',
        action: (params) => {
            const { entity, entityId, queryString } = params;

            if (!entity || !entityId) {
                console.warn('Missing required parameters: entity and entityId are required');
                return false;
            }

            const entityObject = getEntityFromString(entity);
            if (!entityObject) {
                console.warn(`Unknown entity type: ${entity}`);
                return false;
            } else {
                ensureRoute(`${entityObject.route}/${entityId}`, queryString);
            }
        },
    },
};

export const getCopilotActions = (type) => {
    if (!type) {
        console.warn('getCopilotActions: type parameter is required');
        return null;
    }

    const actionDefinition = ACTION_DEFINITIONS[type];
    if (!actionDefinition) {
        console.warn(`getCopilotActions: Unknown action type '${type}'`);
        return null;
    }

    return actionDefinition;
};
